import { PreloadImage } from '$util/PreloadImage';
import { Card } from '$components/basic/Card';
import MainTitle from '$layout/partials/MainTitle';
import { nutHeaderSrc } from '$layout/partials/TopBackground';
import { PartOfRenault } from '$quantum/molecules/PartOfRenault';
import Styled from './styled';

export default function TopSection() {
  return (
    <>
      <PreloadImage provider="cloudinary" href={nutHeaderSrc} displayFrom="lg" />
      <Styled className="TopSection">
        <hgroup>
          <MainTitle
            subTitle={`Fixter was launched in 2017 to change the experience of car maintenance
          for our customers, by making it as easy as ordering a takeaway.`}
          >
            About Fixter
          </MainTitle>
        </hgroup>
        <Card className="main-card" shadow="big">
          <div>
            <p className="title">
              Our mission is to take the hassle out of looking after your car, by providing a complete,
              affordable, end-to-end service with a world-class customer experience.
            </p>
            <p className="content">
              Our in-house mechanics personally select each garage we work with, directly negotiate prices
              with them and always review their top-notch services on our clients cars.
            </p>
          </div>
        </Card>
        <div className="part-of-renault">
          <PartOfRenault />
        </div>
      </Styled>
    </>
  );
}
